import { cloneDeep, isEmpty } from 'lodash';

export const addQuizNavigation = ({
  navigation,
  quiz,
  adminAndGuardianMode,
}) => {
  const replacedNavigation = cloneDeep(navigation);

  const { isLastQuestion } = quiz.data;

  const { onNext } = replacedNavigation.actions;

  replacedNavigation.data.isNextAvailable =
    quiz.data.submitEnabled || adminAndGuardianMode;
  replacedNavigation.actions.onNext = async () => {
    const submitted = await quiz.actions.submitAnswer();
    if ((isLastQuestion && submitted) || adminAndGuardianMode) {
      onNext();
    }
  };

  return replacedNavigation;
};

export const addSurveyNavigation = ({
  navigation,
  survey,
  isCompleted,
  showSurveyDescription,
  setShowSurveyDescription,
  t,
}) => {
  const replacedNavigation = cloneDeep(navigation);
  const hasDescription = !isEmpty(survey.data?.description);

  replacedNavigation.data.isNextAvailable = survey.data.isNextAvailable;
  replacedNavigation.data.prevText = survey.data.prevText;
  replacedNavigation.data.nextText = survey.data.nextText;

  // Enable navigating back after first question
  if (survey.data.currentQuestionIndex > 0) {
    replacedNavigation.data.isPrevAvailable = survey.data.isPrevAvailable;
    replacedNavigation.actions.onPrev = survey.actions.onPreviousQuestion;
  }

  // If survey is not completed, onNext move to next question
  if (!isCompleted) {
    replacedNavigation.actions.onNext = survey.actions.onNextQuestion;
  }

  // When navigating back, if we have a description, and we are on the first question, show description step
  if (
    survey.data.currentQuestionIndex === 0 &&
    hasDescription &&
    !showSurveyDescription &&
    !isCompleted
  ) {
    replacedNavigation.actions.onPrev = () => setShowSurveyDescription(true);
    replacedNavigation.data.isPrevAvailable = true;
  }

  // Show description step, if there is a survey description
  if (showSurveyDescription && hasDescription) {
    replacedNavigation.data.nextText = t(
      'LearningTasks.NavigationButtons.StartSurvey',
      { debugAsText: true },
    );
    replacedNavigation.actions.onNext = () => setShowSurveyDescription(false);
  }
  return replacedNavigation;
};

export const addElementaryPrefix = ({ isElementary }) =>
  isElementary ? '/el' : '';
